export default class Utilities {

      /**
    * Returns whether a date is valid.
    * Month is 1 - January, 2 - February, etc.
    * Modified from http://www.codetoad.com/javascript_IsValidDate.asp
    */
    static isValidDate (day, month, year) {
        if(day && month && year){
            if(year.toString().length == 4){
                let dteDate;
                dteDate = new Date(year, (month - 1), day);
                return ((day == dteDate.getDate()) && ((month - 1) == dteDate.getMonth()) && (year == dteDate.getFullYear()));
            }else{
                return false;
            }
        }else{
            return false;
        }
    }

   /**
    * Creates a dialog that has the title specified and whose content includes the image
    * specified by the url.
    */
    static showPhoto (title, url) {
        // var photodialog = new dijit.Dialog({ title: title,
        //     content: '<img src="' + url + '"></img>'
        // });
        // dojo.body().appendChild(photodialog.domNode);
        // photodialog.startup();
        // dojo.connect(photodialog, 'hide', function () { this.destroyRecursive(); });
        // photodialog.show();
    }

    static escape (string) {
        string = string.replace('\'', '\\\'');
        return string;
    }
}


// WEBPACK FOOTER //
// ./app/utilities.ts